import { GET_DEFAULT_CARRIERS_FAILURE, GET_DEFAULT_CARRIERS_REQUEST, GET_DEFAULT_CARRIERS_REST, GET_DEFAULT_CARRIERS_SUCCESS } from "@/redux/actions/RateManagement/GetDefaultCarriers";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getDefaultCarriersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DEFAULT_CARRIERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_DEFAULT_CARRIERS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_DEFAULT_CARRIERS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_DEFAULT_CARRIERS_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getDefaultCarriersReducer;
